import React, { Fragment, useEffect, useState } from "react";
import CommonBanner from "../components/Common Banner Component/HeroBanner"
import Blogs from "../components/Blogs/Blogs";
import CardBlog from "../components/CardBlog/CardBlog"
import IdvBlogSec from "../components/IdvBlogSec/IdvBlogSec";
import { useParams } from "react-router";
import axios from "axios";
import { Spinner } from "react-bootstrap";

const IdvBlog = () => {
  const [blogsData, setBlogsData] = useState();

  const [loading, setLoading] = useState(true);

  const { id } = useParams();

  let blogAPICalledId = false;
  let allBlogsCalled = false;

  const getAllBlogs = async () => {
    if (allBlogsCalled) return;
    allBlogsCalled = true;

    setLoading(true);
    axios
      .get(`http://localhost:5000/blogs`, {})
      .then((res) => {
        if (res.data.status === "success") {
          let blog = res.data.data.find((item) => item.slug_url == id);
          setBlogsData(blog);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllBlogs();
  }, [id]);

  return (
    <>
      <Fragment>
        {loading && !blogsData ? (
          <div
            style={{ width: "100%", height: "100vh" }}
            className="d-flex justify-content-center align-items-center"
          >
            <Spinner
              style={{ color: "blue", width: "120px", height: "120px" }}
            />
          </div>
        ) : (
          blogsData && (
            <>
              <CommonBanner
                  subHeading=""
                  Heading={blogsData.title}
                  Paragraph=""
                  btnText=""
                  bgImg="/images/creative/news-bg.jpg"
                  btn={false}
              />
              <IdvBlogSec
                blogsData={blogsData.blogs_content}
                datePublished={blogsData.published_date}
                text={blogsData.brief_paragraph}
              />
              <CardBlog />
            </>
          )
        )}
      </Fragment>
    </>
  );
};

export default IdvBlog;
